import { render } from "./DeleteDiagramModal.vue?vue&type=template&id=46fe21ce"
import script from "./DeleteDiagramModal.vue?vue&type=script&lang=js"
export * from "./DeleteDiagramModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__